import { Instance } from 'mobx-state-tree';
import { RouteDeletingDtoModelBase } from './RouteDeletingDtoModel.base';

/* The TypeScript type of an instance of RouteDeletingDtoModel */
export interface RouteDeletingDtoModelType extends Instance<typeof RouteDeletingDtoModel.Type> {}

/* A graphql query fragment builders for RouteDeletingDtoModel */
export { selectFromRouteDeletingDto, routeDeletingDtoModelPrimitives, RouteDeletingDtoModelSelector } from './RouteDeletingDtoModel.base';

/**
 * RouteDeletingDtoModel
 *
 * Route deleting event
 */
export const RouteDeletingDtoModel = RouteDeletingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
